import { useLoaderData, useRouteLoaderData } from "react-router-dom";
import { Organization } from "../../../services/organization/organizationModel";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { ReturnButton } from "../../../components/ReturnButton";
import { PremiumSponsorship } from "../../../services/premiumSponsorship/premiumSponsorshipModel";
import InvitePremiumSponsorshipsDialog from "./InvitePremiumSponsorshipsDialog";
import PremiumSponsorshipsTable from "./PremiumSponsorshipsTable";
import PremiumSponsorshipsOverview from "./PremiumSponsorshipsOverview";
import { useSearch } from "../../../react-helpers/array";

const PremiumSponsorshipPage = () => {
  const { t } = useTranslation(["organization"]);
  const { organization } = useRouteLoaderData("organization") as {
    organization: Organization;
  };
  const { sponsorships } = useLoaderData() as {
    sponsorships: PremiumSponsorship[];
  };
  const [isInviteDialogOpen, setInviteDialogOpen] = useState(false);
  const [searchedSponsorships, setSearch] = useSearch(
    sponsorships,
    (sponsorship) => sponsorship.email,
  );

  return (
    <div className="layout_content --bg--organization-dashboard">
      <div className="page-content container --wrap">
        <ReturnButton fallbackUrl="../.." />
        <h1 className="page_title">
          {t("organization:premium-sponsorship.PAGE_TITLE")}
        </h1>
        <p className="lblock--l">
          {t("organization:premium-sponsorship.SUBTITLE")}
        </p>

        <div className="lblock lrow --stretch--v">
          <PremiumSponsorshipsOverview
            organization={organization}
            sponsorships={sponsorships}
            onInvite={() => setInviteDialogOpen(true)}
          />
        </div>

        <div className="lblock">
          <div className="lblock--l grid-3">
            <input
              type="text"
              className="input"
              placeholder={t(
                "organization:premium-sponsorship.SEARCH_SPONSORSHIPS",
              )}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <PremiumSponsorshipsTable
            organization={organization}
            sponsorships={searchedSponsorships}
          />
        </div>
      </div>

      {isInviteDialogOpen && (
        <InvitePremiumSponsorshipsDialog
          onClose={() => setInviteDialogOpen(false)}
          organization={organization}
          sponsorships={sponsorships}
        />
      )}
    </div>
  );
};

export default PremiumSponsorshipPage;
